import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../../types/userType";
import { RootState } from "../store";
import { AppType } from "types/appType";
import { ExtractErrorInfo } from "../../components/shared/ExtractErrorInfo";
import { api } from "Config/Api";
import { ThemeType } from "types/themeType";
import { getThemeType } from "utils/getThemeType";
import { API_ENDPOINTS } from "Config/apiConfig";

export interface AppTypeWithUserType extends AppType {
  userType: UserType;
  theme: ThemeType | null;
}

const initialState: AppTypeWithUserType = {
  error: null,
  loading: false,
  userType: {
    id: "",
    firstName: "",
    givenName: "",
    email: "",
    role: "",
    organisation: { id: "", name: "", role: "" },
    client: { name: "", reference: "" },
    active: false,
    permissions: [],
  },
  theme: null,
};

export const getUserInfo = createAsyncThunk<UserType, string>(
  "users/getUserInfo",
  async (userId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get<UserType>(`${API_ENDPOINTS.users}/${userId}`);
      return response.data;
    } catch (error: any) {
      const errorInfo = ExtractErrorInfo(error);
      return rejectWithValue(errorInfo);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<UserType>) => {
      return {
        ...state,
        userType: action.payload,
        error: null,
        loading: false,
        theme: getThemeType(action.payload.client.name),
      };
    },
    //TODO: - just a temporary function to toggle between clients
    toggleClient: (state) => {
      if (state.userType.client.name === "R2C") {
        state.userType.client.name = "SN";
        state.theme = getThemeType("SN");
      } else {
        state.userType.client.name = "R2C";
        state.theme = getThemeType("R2C");
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserInfo.fulfilled, (state, action: PayloadAction<UserType>) => {
      return {
        ...state,
        loading: false,
        error: null,
        userType: action.payload,
        theme: getThemeType(action.payload.client.name),
        permissions: action.payload.permissions,
      };
    });
    builder.addCase(getUserInfo.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getUserInfo.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { setCurrentUser, toggleClient } = userSlice.actions;

export const userRootState = (state: RootState) => state;
export default userSlice.reducer;
